import { create } from 'zustand'

interface CompactorState {
  running: boolean
  /** Which cache is being walked right now. */
  phase: 'images' | 'avatars' | null
  /** Current compression tier (1 = gentlest). */
  tier: number
  done: number
  total: number
  /** Origin-storage bytes reclaimed by the last completed run (estimate
   *  delta — includes opaque-padding removal, so it can dwarf the byte
   *  savings of the re-encodes themselves). */
  freedBytes: number | null
  finishedAt: number | null
  /** Set when even tier-3 compression can't get under the high-water mark.
   *  Nothing is ever deleted — this surfaces so the user knows the disk
   *  itself is the constraint. */
  warning: string | null

  start: () => void
  progress: (p: { phase: 'images' | 'avatars'; tier: number; done: number; total: number }) => void
  finish: (freedBytes: number, warning: string | null) => void
}

export const useCompactorStore = create<CompactorState>((set) => ({
  running: false,
  phase: null,
  tier: 1,
  done: 0,
  total: 0,
  freedBytes: null,
  finishedAt: null,
  warning: null,

  start: () => set({ running: true, phase: 'images', tier: 1, done: 0, total: 0, freedBytes: null, warning: null }),
  progress: (p) => set(p),
  finish: (freedBytes, warning) =>
    set({ running: false, phase: null, freedBytes, finishedAt: Date.now(), warning }),
}))
